import { Component } from 'react';
import { AlertTriangle } from 'lucide-react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // ✅ Extrair mensagem de forma segura
    let errorMessage = 'Algo deu errado';
    
    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else if (error?.message) {
      errorMessage = error.message;
    }

    return { 
      hasError: true, 
      error: errorMessage
    };
  }

  componentDidCatch(error, errorInfo) {
    // Log seguro do erro
    console.error('Erro capturado por ErrorBoundary:', {
      message: error instanceof Error ? error.message : String(error),
      componentStack: errorInfo.componentStack
    });
    
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4 p-4 bg-gray-50 dark:bg-gray-900">
          <AlertTriangle className="h-16 w-16 text-red-600" />
          <h1 className="text-2xl md:text-3xl font-bold text-red-600">
            Oops! Algo deu errado
          </h1>
          <p className="text-center text-gray-600 dark:text-gray-400 max-w-md">
            {this.state.error || 'Erro desconhecido'}
          </p>
          
          {process.env.NODE_ENV === 'development' && this.state.errorInfo && (
            <details className="mt-6 max-w-2xl">
              <summary className="cursor-pointer font-semibold text-gray-700 dark:text-gray-300">
                Detalhes técnicos (desenvolvimento)
              </summary>
              <pre className="mt-2 p-4 bg-gray-100 dark:bg-gray-800 rounded text-xs overflow-auto max-h-64">
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}

          <button
            onClick={() => window.location.reload()}
            className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Recarregar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}